import * as types from "redux/types";
import { getDayName } from "utils/globalFunction";


const initialState = {
  inputDrawer: false,
  chartData: [

  ]
};


const indexReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.CHANGE_STOCK: {
      const { prop, value } = payload;
      return {
        ...state,
        [prop]: value,
      };
    }

   
    case types.CHANGE_STOCK_CHART: {
      const { items } = payload;
      // var quotes = JSON.parse(res.item.quotes.replace('\\', ""))
      var hAxis = []
      var newChartData = [["day","", "", "", ""], ]
      //  items.map((data, index) => {
      //   hAxis.push(`a${index}`);
      // })
      // newChartData.push(hAxis)
      items.sort((function(a, b){return parseInt(a.date) - parseInt(b.date)})).map((data, index) => {
        var price_info = JSON.parse(data.price_info)
        
        newChartData.push([data.date,price_info.low_price, price_info.open_price, price_info.real_close_price, price_info.high_price])
      })
      
      
      return {
        ...state,
        chartData: newChartData
      };
    }
    case types.CHANGE_STOCK_VIEW: {
      const res = payload;
      var quotes = JSON.parse(res.item.quotes.replace('\\', ""))
      var lastBidAsks = JSON.parse(res.item.lastBidAsks.replace('\\', ""))
      console.log("quotes")
      console.log(quotes)
      console.log(lastBidAsks)
      // console.log(quotes.find((q) => q.item === "quotes").days[0].items.find((a) => a.item === "adjusted"))
      return {
        ...state,
        quotes:quotes,
        lastBidAsks:lastBidAsks.sort(function(a, b){return a.order_rank - b.order_rank}),
        // open_price: quotes.find((q) => q.item === "quotes").days[0].items.find((a) => a.item === "adjusted").values.closeAdjusted,
        // closeAdjusted: quotes.find((q) => q.item === "quotes").days[0].items.find((a) => a.item === "adjusted").values.closeAdjusted,
        // vwapAdjusted: quotes.find((q) => q.item === "quotes").days[0].items.find((a) => a.item === "adjusted").values.vwapAdjusted,
        // vwapAdjustedPrevious: quotes.find((q) => q.item === "quotes").days[0].items.find((a) => a.item === "adjusted").values.vwapAdjustedPrevious,
        // openAdjusted: quotes.find((q) => q.item === "quotes").days[0].items.find((a) => a.item === "adjusted").values.openAdjusted,
        // baseVolume: quotes.find((q) => q.item === "quotes").days[0].items.find((a) => a.item === "baseVolume").values.baseVolume,
        // outstandingShares: quotes.find((q) => q.item === "quotes").days[0].items.find((a) => a.item === "share").values.outstandingShares,
        // float: quotes.find((q) => q.item === "quotes").days[0].items.find((a) => a.item === "share").values.float,
        // numOfTrades: quotes.find((q) => q.item === "quotes").days[0].items.find((a) => a.item === "adjusted").values.numOfTrades,
        // volume: quotes.find((q) => q.item === "quotes").days[0].items.find((a) => a.item === "adjusted").values.volume,
        // value: quotes.find((q) => q.item === "quotes").days[0].items.find((a) => a.item === "adjusted").values.value,
        // marketCap: quotes.find((q) => q.item === "quotes").days[0].items.find((a) => a.item === "share").values.marketCap,
        // minAuthorizedValue: quotes.find((q) => q.item === "quotes").days[0].items.find((a) => a.item === "authorizedPrice").values.minAuthorizedValue,
        // maxAuthorizedValue: quotes.find((q) => q.item === "quotes").days[0].items.find((a) => a.item === "authorizedPrice").values.maxAuthorizedValue,
        // highAdjusted: quotes.find((q) => q.item === "quotes").days[0].items.find((a) => a.item === "adjusted").values.highAdjusted,
        // lowAdjusted: quotes.find((q) => q.item === "quotes").days[0].items.find((a) => a.item === "adjusted").values.lowAdjusted,
        // ind_buyVolume: quotes.find((q) => q.item === "indinst").days[0].items.find((a) => a.item === "ind").values.buyVolume,
        // ind_sellVolume: quotes.find((q) => q.item === "indinst").days[0].items.find((a) => a.item === "ind").values.sellVolume,

        // ind_buyNumOfTrades: quotes.find((q) => q.item === "indinst").days[0].items.find((a) => a.item === "ind").values.buyNumOfTrades,
        // ind_sellNumOfTrades: quotes.find((q) => q.item === "indinst").days[0].items.find((a) => a.item === "ind").values.sellNumOfTrades,

        // inst_buyVolume: quotes.find((q) => q.item === "indinst").days[0].items.find((a) => a.item === "inst").values.buyVolume,
        // inst_sellVolume: quotes.find((q) => q.item === "indinst").days[0].items.find((a) => a.item === "inst").values.sellVolume,

        // inst_buyNumOfTrades: quotes.find((q) => q.item === "indinst").days[0].items.find((a) => a.item === "inst").values.buyNumOfTrades,
        // inst_sellNumOfTrades: quotes.find((q) => q.item === "indinst").days[0].items.find((a) => a.item === "inst").values.sellNumOfTrades,


        // bidAsks: lastBidAsks[0].bidAsks
      };
    }
    default:
      return state;
  }
};



export default indexReducer;


